import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { FOOD_MOOD_QUERY } from '../graphql/queries'
import { FETCH_FOOD_MOOD } from '../redux/action-types'
import { cleanupFetchFoodMood } from '../redux/actions'

const useFoodMoodQuery = id => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchFoodMood)

  const { isFetchLoading, fetchError, data } = useSelector(
    store => store.foodMoods.foodMood,
  )

  const refetch = useCallback(
    id =>
      apolloService.query(FOOD_MOOD_QUERY, { id }, dispatch, FETCH_FOOD_MOOD),

    [dispatch],
  )

  useEffect(() => {
    refetch(id)
  }, [id, refetch])

  return { isLoading: isFetchLoading, error: fetchError, data, refetch }
}

export default useFoodMoodQuery
